import { render, staticRenderFns } from "./NewPage.vue?vue&type=template&id=59d5aefc"
import script from "./NewPage.vue?vue&type=script&lang=js"
export * from "./NewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports